import { useState } from "react";

/**
 * Manages the "pick a raw file (or an already-uploaded image URL) -> crop it
 * -> hand off the cropped File" flow used by every image upload/re-crop point
 * in the admin panel. Wire a file input's onChange to `selectFile` (new
 * upload) or a "Re-crop" button to `selectUrl` (adjust an existing photo).
 * Render <ImageCropModal open={isOpen} imageSrc={imageSrc} fileName={fileName}
 * onCancel={cancel} onConfirm={confirm} />, and `onCropped` fires with the
 * final cropped File once the admin confirms.
 */
export const useImageCrop = (onCropped) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [isObjectUrl, setIsObjectUrl] = useState(false);

  const selectFile = (file) => {
    setFileName(file.name);
    setImageSrc(URL.createObjectURL(file));
    setIsObjectUrl(true);
  };

  const selectUrl = (url, fallbackName = "photo.jpg") => {
    setFileName(fallbackName);
    setImageSrc(url);
    setIsObjectUrl(false);
  };

  const reset = () => {
    if (isObjectUrl && imageSrc) URL.revokeObjectURL(imageSrc);
    setImageSrc(null);
    setFileName(null);
  };

  const cancel = () => reset();

  const confirm = (croppedFile) => {
    reset();
    onCropped(croppedFile);
  };

  return { isOpen: !!imageSrc, imageSrc, fileName, selectFile, selectUrl, cancel, confirm };
};

